import { ForgeProjectInvitation } from "./SDKForgeProjectInvitation";
import { ForgeProjectMembership } from "./SDKForgeProjectMembership";
export class ForgeProjectMembersList {
    constructor(model) {
        this.members = model.members.map((member) => new ForgeProjectMembership(member));
        this.invitations = model.invitations.map((invitation) => new ForgeProjectInvitation(invitation));
    }
    toRemote() {
        return {
            members: this.members.map((member) => member.toRemote()),
            invitations: this.invitations.map((invitation) => invitation.toRemote()),
        };
    }
}
